import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';

export const initialState = {
  // Assumption Modules
  modules: [],
  selectedModule: null,
  selectedModuleId: null,
  selectedModuleIsOpen: false,
  modulesAreLoading: false,
  selectedModuleIsLoading: false,
  selectedModuleIsDirty: false,
  saveModuleDialogParameters: {
    dialogIsOpen: false,
    navigateToModuleId: null,
    navigateToModule: null,
  },
};

const slice = createSlice({
  name: 'assumptionModulesSlice',
  initialState,
  reducers: {
    // Modules
    setModules: (state, action) => {
      state.modules = action.payload;
    },
    setSelectedModule: (state, action) => {
      state.selectedModule = action.payload;
    },
    setSelectedModuleIsOpen: (state, action) => {
      state.selectedModuleIsOpen = action.payload;
    },
    setModulesAreLoading: (state, action) => {
      state.modulesAreLoading = action.payload;
    },
    setSelectedModuleIsLoading: (state, action) => {
      state.selectedModuleIsLoading = action.payload;
    },
    setSelectedModuleIsDirty: (state, action) => {
      state.selectedModuleIsDirty = action.payload;
    },
    setSelectedModuleId: {
      reducer: (state, action) => {
        state.selectedModuleId = action.payload.selectedModuleId;
      },
      prepare: (selectedModuleId) => ({
        payload: { selectedModuleId },
      }),
    },
    setSaveModuleDialogParameters: {
      reducer: (state, action) => {
        state.saveModuleDialogParameters = action.payload;
      },
      prepare: (dialogIsOpen, navigateToModuleId, navigateToModule) => ({
        payload: {
          dialogIsOpen,
          navigateToModuleId,
          navigateToModule,
        },
      }),
    },

    // Redux saga actions, no reducers
    fetchAssumptionModules: () => {},
    createAssumptionModule: () => {},
    updateAssumptionModule: () => {},
    deleteAssumptionModule: () => {},
  },
});

export default slice.reducer;

export const assumptionModulesActions = slice.actions;

export const assumptionModulesSelectors = {
  modulesSelector: createSelector(
    (state) => state.assumptionModulesState.modules,
    (modules) => modules
  ),
  selectedModuleSelector: createSelector(
    (state) => state.assumptionModulesState.selectedModule,
    (selectedModule) => selectedModule
  ),
};
